import React from 'react';
import Highcharts from 'highcharts/highstock'

import HighchartsReact from 'highcharts-react-official'
import accessibility from 'highcharts/modules/accessibility';
import moment from 'moment';

accessibility(Highcharts);




const T = {
  bg: '#F6F5F0',
  nav: '#FFFFFF',
  soft: '#F0EEE6',
  line: '#E5E2D8',
  ink: '#232821',
  mut: '#6E766C',
  acc: '#2E9E7A',
};

const CustomRatiosHighchart = (props) => {
    const { seriesData } = props

    const options = React.useMemo(() => ({

        chart: {
            type: 'line',
            renderTo: 'container'
        },
        credits: {
            enabled: false
        },

        navigator: {
            enabled: false
        },

        scrollbar: {
            enabled: false,
        },

        exporting: {
            enabled: false
        },

        legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle'
        },

        plotOptions: {
            series: {
                label: {
                    connectorAllowed: false
                },
            }
        },

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 400
                }
            }]
        },

        yAxis: {
            opposite: false,
            title: false,
            tickLength: 0,
            lineWidth: 0,
        },

        xAxis: {
            title: false,
            tickLength: 0,
            lineWidth: 0,
            labels: {
                formatter: function () {
                    return moment(new Date(this.value)).format('MMM yyyy')
                }
            }
        },

        tooltip: {
            pointFormatter: function () {
                return (
                    `<b><span style="color:${this.series.color}">${this.series.name}</span>: </b>
                   ${moment(new Date(this.x)).format('DD MMM yyyy')}
                ${Highcharts.numberFormat(this.y, 2, '.', ',')}`
                )
            }

        },

        rangeSelector: {
            enabled: true,
            allButtonsEnabled: true,
            selected: 3,
            buttonPosition: {
                align: 'left',

            },

            // styles for the buttons
            buttonTheme: {
                fill: 'transparent',
                stroke: 'none',
                'stroke-width': 0,
                r: 8,
                style: {
                    color: T.mut,
                    fontWeight: '600'
                },
                states: {
                    hover: {
                        fill: T.soft,
                        style: {
                            color: T.ink
                        }
                    },
                    select: {
                        fill: T.ink,
                        style: {
                            color: T.bg
                        }
                    }
                    // disabled: { ... }
                }
            },
            inputBoxBorderColor: T.line,
            inputBoxWidth: 120,
            inputBoxHeight: 24,
            inputStyle: {
                color: T.ink,
                fontWeight: '600',
                fontFamily: "'Instrument Sans', system-ui, sans-serif",
                fontSize: '12px',
                outline: 'none'
            },
            labelStyle: {
                color: T.mut,
                fontWeight: '600',
                fontFamily: "'Instrument Sans', system-ui, sans-serif",
            },

            buttons: [
                {
                    type: 'year',
                    count: 5,
                    text: '5y',

                }, {
                    type: 'year',
                    count: 7,
                    text: '7y',
                }, {
                    type: 'year',
                    count: 9,
                    text: '10y',
                }]
        },

        series: seriesData,

    }), [seriesData]);
    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
            constructorType={'stockChart'}

        />
    )
}

export default React.memo(CustomRatiosHighchart)